import { render } from "./LandingPage.vue?vue&type=template&id=d84f1c7c&scoped=true"
import script from "./LandingPage.vue?vue&type=script&lang=js"
export * from "./LandingPage.vue?vue&type=script&lang=js"

import "./LandingPage.vue?vue&type=style&index=0&id=d84f1c7c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d84f1c7c"

export default script